import React, { useState } from "react";
import CheckBox from "Components/common/CheckBox";
import { confirmationPopupState } from "Components/common/confirmationPopup";

const ExportActivitiesCheckBox = ({ id = "", onChange = () => {} }) => {
  const [checked, setChecked] = useState(false);
  return (
    <CheckBox
      id={id}
      name="Also export activities (emails, calls, LinkedIn and tasks)"
      checked={checked}
      cbk={value => {
        setChecked(value);
        onChange(value);
      }}
    />
  );
};

// Confirms a CRM (HubSpot / Pipedrive / Zoho / Salesforce) contact export; onConfirm receives whether past activities should be exported too.
const confirmHubspotExport = (onConfirm = () => {}, crmName = "HubSpot") => {
  let exportActivities = false;
  confirmationPopupState.setPopupValues({
    content: (
      <div className="hubspotExportConfirm">
        <div className="initText">
          {`Export the selected contacts to ${crmName}?`}
        </div>
        <ExportActivitiesCheckBox
          id={`export${crmName}Activities`}
          onChange={value => {
            exportActivities = value;
          }}
        />
      </div>
    ),
    actionBtnText: "Export",
    callback: () => onConfirm(exportActivities),
    dynamicDom: true
  });
  confirmationPopupState.setShowPopup(true);
};

export default confirmHubspotExport;
